import PropTypes from 'prop-types';
import classNames from 'classnames';

import Metrics from '@spotahome/soyuz-tracking';

import CarouselItem from './CarouselItem';
import './CarouselItemsWrapper.scss';

const CarouselItemsWrapper = ({
  isVertical,
  isFullScreen,
  carouselWidth,
  carouselHeight,
  trackData,
  onClick,
  selectedTrack,
  carouselRef
}) => {
  const carouselClassName = classNames('carousel-items-wrapper', {
    'carousel-items-wrapper--vertical': isVertical,
    'carousel-items-wrapper--fullscreen': isFullScreen
  });

  const fullScreenStyle = {
    width: carouselWidth
  };

  const fullScreenVerticalStyle = {
    width: carouselWidth,
    height: carouselHeight
  };

  const handleTrackClick = i => () => {
    onClick(i, trackData[i]);

    if (trackData[i].type === 'viewer360') {
      Metrics.hotjar.triggerEvent('listing-photos360-click');
    }
  };

  return (
    <div
      className={carouselClassName}
      ref={carouselRef}
      style={isVertical ? fullScreenVerticalStyle : fullScreenStyle}
    >
      {trackData.map((track, i) => (
        <CarouselItem
          handleTrackClick={handleTrackClick(i)}
          isFullScreen={isFullScreen}
          isSelected={selectedTrack === i}
          key={track.type}
          type={track.type}
        />
      ))}
    </div>
  );
};

CarouselItemsWrapper.propTypes = {
  onClick: PropTypes.func.isRequired,
  trackData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedTrack: PropTypes.number,
  isVertical: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  carouselWidth: PropTypes.string.isRequired,
  carouselHeight: PropTypes.string.isRequired,
  carouselRef: PropTypes.shape({})
};

CarouselItemsWrapper.defaultProps = {
  isVertical: false,
  isFullScreen: false,
  selectedTrack: -1,
  carouselRef: null
};

export default CarouselItemsWrapper;
